import { useMemo } from "react"
import { CARD_GAME_CURRENCY, useGetBalanceQuery } from "@/store/apis/balanceAPI"

export const useGameMoneyEnough = (
  amount: number,
  currency: CARD_GAME_CURRENCY
) => {
  const { data: balance } = useGetBalanceQuery()

  const isMoneyEnough = useMemo(() => {
    if (!balance) return false

    return balance[currency] >= amount
  }, [amount, currency, balance])

  return isMoneyEnough
}
